module.exports = __webpack_public_path__ + "static/media/1-1.c5bb5693.svg";